import { useMemo } from 'react'

import { Capacitor } from '@capacitor/core'
import { isPlatform } from '@ionic/react'
import { useQuery } from 'react-query'

import runPWATests from 'services/pwa-test'

const useDeviceCompatibility = () => {
  const isIOS = isPlatform('ios')
  const isNative = Capacitor.isNativePlatform()
  const {
    data: features,
    isFetching,
    error,
    refetch,
  } = useQuery('features', runPWATests)

  const isCompatible = useMemo(() => {
    // In native platforms, PWA features may not be necessary
    // or available in a different way
    if (isNative) {
      return (
        features &&
        features.indexedDB &&
        features.createObjectURL &&
        features.geolocation
      )
    }

    // For PWA, we check all required features
    return (
      features &&
      features.serviceWorker &&
      features.indexedDB &&
      features.cacheAPI &&
      features.createObjectURL &&
      features.geolocation &&
      (features.diskSpace.persistent || isIOS)
    )
  }, [features, isIOS, isNative])

  return { features, isFetching, error, refetch, isCompatible, isIOS, isNative }
}

export default useDeviceCompatibility
